import React from 'react';
import styled from 'styled-components';
import { Input, Icon, Checkbox, Space, Button, Divider } from 'components';
import { FilterDropdownProps } from 'antd/lib/table/interface';
import ManageUsersContext from '../ManageUsersContext';

const BranchFilterDropdown: React.FC<FilterDropdownProps> = ({
  confirm,
  visible,
}) => {
  const {
    branchFilterText,
    branchOptions,
    filteredBranchOptions,
    setBranchFilterText,
    setFilteredBranchOptions,
    setLocations,
    resetFilteredBranchOptions,
  } = React.useContext(ManageUsersContext);

  React.useEffect(() => {
    if (visible) resetFilteredBranchOptions();
  }, [visible, resetFilteredBranchOptions]);

  const handleSubmit = () => {
    setLocations(
      Object.keys(filteredBranchOptions).filter(
        key => filteredBranchOptions[key],
      ),
    );
    confirm();
  };

  return (
    <StyledBranchFilter direction="vertical">
      <Input
        placeholder="Search"
        value={branchFilterText}
        onChange={e => setBranchFilterText(e.target.value)}
        suffix={<Icon type="search" color="gray5" />}
      />
      <StyledBranchOptions direction="vertical">
        {branchOptions
          .filter(({ label }) =>
            label.toLowerCase().includes(branchFilterText.toLowerCase()),
          )
          .map(({ label, value }) => (
            <Checkbox
              key={value}
              checked={filteredBranchOptions[value]}
              onChange={e =>
                setFilteredBranchOptions({
                  ...filteredBranchOptions,
                  [value]: e.target.checked,
                })
              }
            >
              {label}
            </Checkbox>
          ))}
      </StyledBranchOptions>
      <StyledDivider />
      <StyledButtonWrapper>
        <Button type="link" onClick={() => setFilteredBranchOptions({})}>
          Reset
        </Button>
        <Button type="primary" onClick={handleSubmit}>
          OK
        </Button>
      </StyledButtonWrapper>
    </StyledBranchFilter>
  );
};

export default BranchFilterDropdown;

const StyledDivider = styled(Divider)`
  margin: 0;
`;
const StyledButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`;

const StyledBranchFilter = styled(Space)`
  padding: 12px;
`;

const StyledBranchOptions = styled(Space)`
  overflow-y: auto;
  max-height: 30vh;
  width: 100%;
`;
